// Plan names arrive lowercased from the API and can be multi-word ("branded app"),
// so capitalise every word rather than just the first character.
export const titleCasePlanName = ( name: string ): string => {
    if ( !name ) {
        return '';
    }
    return name
        .split( ' ' )
        .map( ( word: string ) => word.charAt( 0 ).toUpperCase() + word.slice( 1 ) )
        .join( ' ' );
};

export enum BillingCycles {
    MONTHLY = "monthly",
    YEARLY = "yearly",
    LIFETIME = "one_time",
}

export enum PlanNames {
    PRO = "pro",
    PREMIUM = "premium",
    BASIC = "basic",
    BUSINESS = "business",
    STARTER = "starter",
    LAUNCH = "launch",
    GROW = "grow",
    BUILD = "build",
    SCALE = "scale",
    ORGANIZATION = "organization",
    BRANDED_APP = "branded app",
    PLUS = "plus",
    FREE = "free",
    ENTERPRISE = "enterprise",

    AppSumo1 = 'appSumo tier 1',
    AppSumo2 = 'appSumo tier 2',
    AppSumo3 = 'appSumo tier 3',
    AppSumo4 = 'appSumo tier 4',

    basicLTD = 'basic LTD',
    proLTD = 'pro LTD',
    proPlusEarlyBird = 'pro plus (early bird)',
    proPlus = 'pro plus',

    Tier4LTD = 'tier 4 LTD',
}